import qs from 'query-string';

import ggAxiosConfig from 'ggApp/modules/axiosConfig';
import axios from 'ggApp/utils/requests';
import CookiesManager, { injectCookiesToConfig } from 'ggApp/utils/CookiesManager';
import loadConfiguration from 'ggApp/utils/configuration';

import {
    PREFETCH_SEARCH_LISTING_DATA,
    PREFETCH_SEARCH_LISTING_DATA_SUCCESS,
    PREFETCH_SEARCH_LISTING_DATA_ERROR,
    FETCH_SEARCH_LISTING_DATA,
    FETCH_SEARCH_LISTING_DATA_SUCCESS,
    FETCH_SEARCH_LISTING_DATA_ERROR,
} from '../actionTypes';

import { SEARCH_INPUT_MAX_LENGTH } from '../constants';

const { APP_CONFIG } = loadConfiguration();
const { apiV2Url } = APP_CONFIG;

export function fetchDefaultProductsForSearch(params, location, req) {
    const cookiesManager = new CookiesManager(req);
    return (dispatch, getState) => {
        const config = ggAxiosConfig.selectors.config(getState());
        injectCookiesToConfig(cookiesManager, config);
        dispatch({ type: PREFETCH_SEARCH_LISTING_DATA });
        const query = qs.stringify({ filter: JSON.stringify({ in_stock: true }), per: 40 });
        return axios
            .get(`${apiV2Url}/products?${query}`, config)
            .then((result) => {
                const products =
                    (result &&
                        result.data &&
                        result.data.data.map((product) => product.attributes)) ||
                    [];
                dispatch({
                    type: PREFETCH_SEARCH_LISTING_DATA_SUCCESS,
                    payload: products,
                });
            })
            .catch(({ response: error = {} }) => {
                if (error.data) {
                    dispatch({
                        type: PREFETCH_SEARCH_LISTING_DATA_ERROR,
                        error: error.data,
                    });
                }
            });
    };
}

export function fetchProductsForSearch(searchInput) {
    return (dispatch, getState) => {
        if (!searchInput || searchInput === '') {
            return dispatch({
                type: FETCH_SEARCH_LISTING_DATA_SUCCESS,
                payload: [],
            });
        }
        const config = ggAxiosConfig.selectors.config(getState());
        const queryStr = searchInput.slice(0, SEARCH_INPUT_MAX_LENGTH);
        const payload = {
            filter: JSON.stringify({ search: queryStr, in_stock: true }),
            per: 40,
        };
        const query = qs.stringify(payload);
        dispatch({ type: FETCH_SEARCH_LISTING_DATA });
        return axios
            .get(`${apiV2Url}/products?${query}`, config)
            .then((result) => {
                const products =
                    (result &&
                        result.data &&
                        result.data.data.map((product) => product.attributes)) ||
                    [];
                const totalItems =
                    (result && result.data && result.data.meta && result.data.meta.total_items) ||
                    0;
                dispatch({
                    type: FETCH_SEARCH_LISTING_DATA_SUCCESS,
                    payload: {
                        products,
                        queryStr,
                        totalItems,
                    },
                });
            })
            .catch(({ response: error = {} }) => {
                if (error.data) {
                    dispatch({
                        type: FETCH_SEARCH_LISTING_DATA_ERROR,
                        error: error.data,
                    });
                }
            });
    };
}
